module.exports = __webpack_public_path__ + "img/62_9.b9450ca9.png";